var pug = require("!../../../../../node_modules/pug-runtime/index.js");

function template(locals) {
var buf = [];
var jade_mixins = {};
var jade_interp;
;var locals_for_with = (locals || {});(function (partner) {
buf.push("<div class=\"contact-header-top\"><h1 class=\"modal-h1\">Send message to " + (jade.escape((jade_interp = partner.displayType().toLowerCase()) == null ? '' : jade_interp)) + "</h1></div><p>To: " + (jade.escape((jade_interp = partner.get('name')) == null ? '' : jade_interp)) + "<span class=\"contact-location\"></span></p>");}.call(this,"partner" in locals_for_with?locals_for_with.partner:typeof partner!=="undefined"?partner:undefined));;return buf.join("");
};
module.exports = template;